import { createUseStyles } from 'react-jss'

export default createUseStyles({
  optionsWrapper: {
    padding: '0 3px'
  }
})
